import { Search, Filter, Check } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { Input } from "../../../components/ui/Input";
import { Button } from "../../../components/ui/button";

export default function FamilleSearch({ search, setSearch, activeFilter, setActiveFilter }) {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filters = [
    { id: "all", label: "Toutes les familles" },
    { id: "audit_requis", label: "Audit requis" },
    { id: "audit_ok", label: "Audit à jour" }
  ];

  return (
    <div className="flex items-center gap-2 w-full sm:w-[320px] relative">
      <div className="relative w-full">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-subtle" />
        <Input
          type="text"
          placeholder="Rechercher une famille..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="pl-9"
        />
      </div>
      
      <div className="relative" ref={popoverRef}>
        <Button 
          variant={activeFilter !== "all" ? "accent" : "secondary"} 
          size="icon" 
          onClick={() => setIsOpen(!isOpen)}
        >
          <Filter className="w-4 h-4" />
        </Button>

        {isOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-surface rounded-[var(--hp-radius-md)] shadow-hp-md border border-workspace z-[100] py-1">
            {filters.map((f) => (
              <button
                key={f.id}
                onClick={() => {
                  setActiveFilter(f.id);
                  setIsOpen(false);
                }}
                className={`w-full text-left px-4 py-2 text-sm flex items-center justify-between hover:bg-surface-muted transition-colors ${activeFilter === f.id ? "text-primary font-semibold" : "text-muted"}`}
              >
                {f.label}
                {activeFilter === f.id && <Check className="w-4 h-4 text-primary" />}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
